import dynamic from 'next/dynamic';

const ServicePointsGrid = dynamic(() =>
  import('./ServicePointsGrid/ServicePointsGrid')
);
const AddServicePointModal = dynamic(() =>
  import('./AddServicePointModal/AddServicePointModal')
);
const ServicePointDetails = dynamic(() =>
  import('./ServicePointDetails/ServicePointDetails').then((mod) => ({
    default: mod.ServicePointDetails,
  }))
);

const AddServicePointAddressModal = dynamic(() =>
  import('./AddServicePointAddressModal/AddServicePointAddressModal')
);
const AddressesGrid = dynamic(() => import('./AddressesGrid/AddressesGrid'));
const EventsGrid = dynamic(() => import('./EventsGrid/EventsGrid'));
const EditServicePointFieldsModal = dynamic(() =>
  import('./EditServicePointFieldsModal/EditServicePointFieldsModal')
);

const AddServicePointWorkdaysModal = dynamic(() =>
  import('./AddServicePointWorkdaysModal/AddServicePointWorkdaysModal')
);
const AddServicePointContactModal = dynamic(() =>
  import('./AddServicePointContactModal/AddServicePointContactModal')
);
const EditServicePointContactModal = dynamic(() =>
  import('./EditServicePointContactModal/EditServicePointContactModal')
);
const ContactsGrid = dynamic(() => import('./ContactsGrid/ContactsGrid'));

const PartnershipDetails = dynamic(() =>
  import('./PartnershipDetails/PartnershipDetails')
);

const ServicePointsMapView = dynamic(() =>
  import('./ServicePointsMapView/ServicePointsMapView')
);

const ServicePointSidebar = dynamic(() => import('./ServicePointSidebar'));
const ServicePointContactsModal = dynamic(() =>
  import('./ServicePointContactsModal')
);

const ToggleServicePointStatus = dynamic(() =>
  import('./ToggleServicePointStatus/ToggleServicePointStatus')
);
const ServicePointsFilters = dynamic(() =>
  import('./ServicePointsFilters/ServicePointsFilters')
);

export {
  ServicePointsGrid,
  ServicePointSidebar,
  AddServicePointModal,
  ServicePointDetails,
  AddServicePointAddressModal,
  AddressesGrid,
  EventsGrid,
  EditServicePointFieldsModal,
  AddServicePointWorkdaysModal,
  AddServicePointContactModal,
  EditServicePointContactModal,
  ContactsGrid,
  PartnershipDetails,
  ServicePointsMapView,
  ServicePointContactsModal,
  ToggleServicePointStatus,
  ServicePointsFilters,
};
